import { AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ConfirmationService } from 'primeng/primeng';
import * as moment from 'moment';
import { DateTimeConverstionService, ErrorHandlerService } from '../../services/index';
var OnlinecourseComponent = /** @class */ (function () {
    function OnlinecourseComponent(dashboardService, router, timeZoneConverstionService, confirmationService, errorHandlerService) {
        this.dashboardService = dashboardService;
        this.router = router;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.confirmationService = confirmationService;
        this.errorHandlerService = errorHandlerService;
        this.onlinecourses = [];
        this.temp = [];
        this.openCourses = [];
        this.openCoursesFilter = {};
        this.allduration = [];
        this.allprice = [];
        this.allcat = [];
        this.coursename = [];
        this.courseownername = [];
        this.searchdata = {};
        this.filtercoursekey = "";
        this.filtercoursename = "";
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.user = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.routeInd = false;
        this.popUp = false;
        this.subscriptions = [];
    }
    OnlinecourseComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    OnlinecourseComponent.prototype.searchcourse = function (event) {
        var _this = this;
        var s1 = this.dashboardService.courseNameAutocomplate(event.query).subscribe(function (data) {
            console.log(data);
            _this.coursename = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s1);
    };
    OnlinecourseComponent.prototype.clearFilter = function () {
        var _this = this;
        var s2 = this.dashboardService.openCourses().subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
            _this.timeZonechange(_this.timezone);
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s2);
    };
    OnlinecourseComponent.prototype.handleDropdownSelect = function (value) {
        var _this = this;
        console.log(value);
        this.searchdata.typeStr = "NameAndKeyWord";
        this.searchdata.courseName = value;
        this.searchdata.keyWords = this.filtercoursekey;
        var s3 = this.dashboardService.searchCourse(this.searchdata).subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
            _this.timeZonechange(_this.timezone);
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s3);
    };
    OnlinecourseComponent.prototype.searchFilter = function () {
        var _this = this;
        this.searchdata.typeStr = "NameAndKeyWord";
        this.searchdata.courseName = this.filtercoursename;
        this.searchdata.keyWords = this.filtercoursekey;
        var s4 = this.dashboardService.searchCourse(this.searchdata).subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
            _this.timeZonechange(_this.timezone);
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s4);
    };
    OnlinecourseComponent.prototype.searchcourseowner = function (event) {
        var _this = this;
        var s5 = this.dashboardService.courseownerNameAutocomplate(event.query).subscribe(function (data) {
            console.log(data);
            _this.courseownername = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s5);
    };
    OnlinecourseComponent.prototype.handletutor = function (event) {
        var _this = this;
        this.searchdata.typeStr = "CourseByUser";
        var val = event.split(' ');
        if (val[0]) {
            this.searchdata.firstName = val[0];
        }
        else {
            this.searchdata.firstName = "";
        }
        if (val[1]) {
            this.searchdata.lastName = val[1];
        }
        else {
            this.searchdata.lastName = "";
        }
        var s6 = this.dashboardService.searchCourse(this.searchdata).subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
            _this.timeZonechange(_this.timezone);
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s6);
    };
    OnlinecourseComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        console.log(this.timezone);
        var s7 = this.dashboardService.openCourses().subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
            _this.temp = data;
            _this.timezone = localStorage.getItem('timezone');
            console.log('init');
            console.log(_this.openCourses);
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            if (_this.timezone) {
                _this.timeZonechange(_this.timezone);
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s7);
        var s8 = this.dashboardService.openCoursesFilters().subscribe(function (data) {
            console.log(data);
            Object.keys(data.courseByPeriodMap).map(function (key) {
                _this.allduration.push(key);
            });
            Object.keys(data.courseByPriceMap).map(function (key) {
                _this.allprice.push(key);
            });
            Object.keys(data.courseByCategoryNameMap).map(function (key) {
                _this.allcat.push(key);
            });
            _this.openCoursesFilter = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s8);
    };
    OnlinecourseComponent.prototype.ngOnInit = function () {
    };
    OnlinecourseComponent.prototype.durationFilter = function (value) {
        var _this = this;
        Object.keys(this.openCoursesFilter.courseByPeriodMap).map(function (key) {
            if (value == key) {
                _this.openCourses = _this.openCoursesFilter.courseByPeriodMap[key];
                _this.timeZonechange(_this.timezone);
            }
        });
    };
    OnlinecourseComponent.prototype.priceFilter = function (value) {
        var _this = this;
        Object.keys(this.openCoursesFilter.courseByPriceMap).map(function (key) {
            if (value == key) {
                _this.openCourses = _this.openCoursesFilter.courseByPriceMap[key];
                _this.timeZonechange(_this.timezone);
            }
        });
    };
    OnlinecourseComponent.prototype.catFilter = function (value) {
        var _this = this;
        Object.keys(this.openCoursesFilter.courseByCategoryNameMap).map(function (key) {
            if (value == key) {
                _this.openCourses = _this.openCoursesFilter.courseByCategoryNameMap[key];
                _this.timeZonechange(_this.timezone);
            }
        });
    };
    OnlinecourseComponent.prototype.catallFilter = function () {
        var _this = this;
        var s9 = this.dashboardService.openCourses().subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
            _this.timeZonechange(_this.timezone);
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s9);
    };
    OnlinecourseComponent.prototype.timeZonechange = function (data) {
        var _this = this;
        this.openCourses.forEach(function (element) {
            element.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseStartDTime);
            element.timeZoneConverted = data;
            element.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseEndDTime);
            element.startTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseStartDTime);
            element.endTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseEndDTime);
        });
        localStorage.setItem('timezone', data);
    };
    OnlinecourseComponent.prototype.convertTimezone = function (timezone, type, datetime) {
        if (type == 'date') {
            var setdate = moment(datetime, 'MM/DD/YYYY');
            return setdate.tz(timezone).format('MM/DD/YYYY');
        }
        else {
            var setdate = moment(datetime, 'HH:mm');
            return setdate.tz(timezone).format('HH:mm');
        }
    };
    OnlinecourseComponent.prototype.convertTimezone1 = function (timezone, type, datetime) {
        if (type == 'date') {
            var setdate = moment(datetime, 'YYYY-MM-DD HH:mm Z');
            return setdate.tz(timezone).format('MM/DD/YYYY');
        }
        else {
            var setdate = moment(datetime + '+00:00', 'HH:mmZ');
            return setdate.tz(timezone).format('HH:mm');
        }
    };
    OnlinecourseComponent.prototype.closeClk = function () {
        console.log('inside close button click');
        //alert('pompa');
        this.popUp = false;
        if (this.routeInd == true) {
            this.routeInd = false;
            this.router.navigate(['dashboard/myenrollment']);
        }
    };
    OnlinecourseComponent.prototype.navigateToQuestionnaire = function (type, qId) {
        if (type == "paid") {
            localStorage.setItem("isPaidSession", "true");
        }
        else {
            localStorage.removeItem("isPaidSession");
        }
        this.router.navigate(['../questionnaire', qId]);
    };
    OnlinecourseComponent.prototype.freeRegister = function (id) {
        var _this = this;
        this.confirmationService.confirm({
            message: "By registering you agree to Uvsity's <a style=\"color:#3917b3\" href=\"https://www.uvsity.com/legal/useragreement.html\" target=\"_blank\"><b><font color=#3917b3>terms of service and privacy policy.</font></b></a>",
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: function () {
                var s10 = _this.dashboardService.registerCourseFree(id).subscribe(function (data) {
                    //this.showSpinner = false;
                    console.log(data);
                    if (data.errorMsg == null) {
                        _this.freeRegisterSuccessful();
                    }
                    else {
                        _this.createInfoAlert(data.errorMsg);
                    }
                }, function (error) {
                    //this.showSpinner = false;
                    _this.handleError(error);
                });
                _this.subscriptions.push(s10);
            },
            reject: function () {
                // do nothing
                console.log("User cancelled registration");
            }
        });
    };
    OnlinecourseComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    //uvsity/issues/92
    OnlinecourseComponent.prototype.freeRegisterSuccessful = function () {
        var _this = this;
        this.confirmationService.confirm({
            message: "You have successfully registered for the session. You will now be taken to your session enrollment page.",
            header: 'Confirmation',
            icon: 'fa fa-question-circle',
            rejectVisible: false,
            accept: function () {
                _this.router.navigate(['dashboard/myenrollment']);
            }
        });
    };
    OnlinecourseComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    OnlinecourseComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return OnlinecourseComponent;
}());
export { OnlinecourseComponent };
//# sourceMappingURL=onlinecourse.component.js.map